import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              {aboutData.title}
            </h2>
            <div className="mt-5 space-y-4">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.desc1}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.desc2}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.desc3}
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 w-64 h-64 md:w-72 md:h-72 rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20illustration%20with%20film%20elements%2C%20soft%20golden%20lighting%2C%20elegant%20minimalist%20style%2C%20movie%20themed%20art%2C%20warm%20amber%20tones%2C%20artistic%20composition&width=600&height=600&seq=about-visual&orientation=squarish"
              alt="木瓜影视品牌介绍"
              className="w-full h-full object-cover"
              loading="lazy"
              width="600"
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
}